<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <!-- Table -->
    <p-table [columns]="cols"
             [value]="restaurants"
             [lazy]="true"
             (onLazyLoad)="handleLazyLoad($event)"
             [paginator]="true"
             [(first)]="first"
             [rows]="rowsPerPage"
             [rowsPerPageOptions]="rowsPerPageOptions"
             [totalRecords]="totalRecords"
             [resizableColumns]="true"
             [columnResizeMode]="'expand'"
             [autoLayout]="true"
             [styleClass]="'p-datatable-striped'"
             [scrollable]="true"
             [scrollHeight]="'flex'">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" class="search-input"
                           [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                           placeholder="Search..." />
                </span>
                <span>
                    <button pButton pRipple type="button" label="Create" class="p-button-success"
                            style="margin-right: 10px;" (click)="handleCreateRestaurantClick()"></button>
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of cols"
                    [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="col.disableSort"
                    pResizableColumn
                    [style.width]="col.width">
                    {{col.header}}
                    <p-sortIcon *ngIf="sortField===col.field" [field]="col.field"></p-sortIcon>
                </th>
                <th>Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-restaurant>
            <tr>
                <td class="ui-resizable-column">{{restaurant.Id}}</td>
                <td class="ui-resizable-column">{{restaurant.CreatedAt}}</td>
                <td class="ui-resizable-column">{{restaurant.Name}}</td>
                <td>
                    <a href="{{restaurant.ImageUrl}}" target="_blank">
                        <img src="{{restaurant.ImageUrl}}" width="100" />
                    </a>
                </td>
                <td>
                    <span class="action-icon-svg" (click)="handleEditRestaurantClick(restaurant)">
                        <img src="../Content/xpress-app/images/svg/icon_edit.svg" />
                    </span>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
            <div *ngIf="restaurants.length > 0" style="padding-left: 10px">
                Displaying {{first + 1}} - {{first + restaurants.length}} of {{totalRecords}}
            </div>
        </ng-template>
    </p-table>
</div>

<edit-restaurant *ngIf="showEditRestaurantPopup"
                 [restaurantId]="editRestaurantId"
                 [onHide]="handleEditRestaurantPopupHide"
                 [onSave]="handleEditRestaurantPopupSave"></edit-restaurant>

<p-toast position="top-right"></p-toast>
